import {section} from "../types/section";
import axiosInstance from '../api/apiInterceptor';
import { AxiosResponse } from 'axios';
import {SECTION_API_ENDPOINT,SECTION_API_ENDPOINT_WITH_FILTER} from "../../../constants/constants";
import {getUserDetails} from "../../../lib/getUserDetails";


export const fetchSectionApi = async (): Promise<section[]> => {
  const userData=getUserDetails();
  const schoolId=userData[0].relatedEntity.schools.id;
  try {
    const response: AxiosResponse<any> = await axiosInstance.get(`${SECTION_API_ENDPOINT_WITH_FILTER}|${schoolId}&limit=1000`);
    return response.data.data;
  } catch (error: any) {
    console.error('Error fetching sections:', error);
    throw error;
  }
};

export const addSectionApi = async (sectionData: Omit<section, 'id'>): Promise<section> => {
  try {
    const response: AxiosResponse<any> = await axiosInstance.post(SECTION_API_ENDPOINT, sectionData);
    return response.data.data;
  } catch (error: any) {
    console.error('Error adding section:', error);
    throw error;
  }
};

export const updateSectionApi = async (sectionData: section): Promise<section> => {
  try {
    const response: AxiosResponse<any> = await axiosInstance.patch(`${SECTION_API_ENDPOINT}/${sectionData.id}`, sectionData);
    return response.data.data;
  } catch (error: any) {
    console.error('Error updating section:', error);
    throw error;
  }
};

export const deleteSectionApi = async (id: number): Promise<number> => {
  try {
    await axiosInstance.delete(`${SECTION_API_ENDPOINT}/${id}`);
    return id;
  } catch (error: any) {
    console.error('Error deleting section:', error);
    throw error;
  }
};